import { Panel, PanelBody, PanelGrid, PanelGridAmount, PanelGridItem } from 'components';
import { DeductionInfoData } from 'types';
import styles from './DeductionInfo.module.scss';
import { formatDate } from 'functions';

type Props = {
    deductionInfo: DeductionInfoData
}

export default function DeductionInfo({ deductionInfo }: Props) {

    return (
        <Panel className={styles.panel}>
            <PanelBody className={styles.body}>
                <PanelGrid className={styles.grid}>
                    <div className={styles.gridItem}>
                        <PanelGridItem
                            label={"Date: "}
                            value={<span>{deductionInfo.invoiceDate ? formatDate(deductionInfo.invoiceDate) : 'date not found'}</span>}
                        />
                    </div>
                    <div className={styles.gridItem}>
                    <PanelGridAmount
                            label={"Amount: "}
                            value={deductionInfo.deductionAmount}
                        />
                    </div>
                    <div className={styles.gridItem}>
                    <PanelGridItem
                            label={"Mock Invoice Number: "}
                            value={<span>{deductionInfo.mockInvoice}</span>}
                        />
                    </div>
                    <div className={styles.gridItem}>
                    <PanelGridItem
                            label={"Deduction Number: "}
                            value={deductionInfo.deductionNumber}
                        />
                    </div>
                    <div className={styles.gridItem}>
                    <PanelGridItem
                            label={"Reference Number: "}
                            value={deductionInfo.referenceNumber}
                        />
                    </div>
                </PanelGrid>

            </PanelBody>
        </Panel>
    )
}